import React, { FC, useCallback } from "react";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import { InputParameters, size, variant } from "../InputParameters";
import { cep, cnpj, cpf, cpfCnpj, creditCard, creditCardCVC, creditCardCVC4, creditCardExpiry, currency, date, dateTime, decimal1, decimal2, decimal3, phone, time, TypeMask } from "src/framework/commons/masks";

export interface InputTextParameters extends InputParameters {
  mask?: TypeMask;
  autofocus?: boolean;

}

const DEFAULT_PARAMENTERS: InputTextParameters = {
  id: undefined,
  label: "",
  size: size.small,
  variant: variant.outlined,
  fullWidth: false,
  margin: "normal",
  type: "text",
  maxLength: undefined,
  minLength: undefined,
  InputLabelProps: undefined,
  autofocus: false,

};

const InputText: FC<InputTextParameters> = (inputParameters: InputTextParameters) => {
  let _parameters: any = { ...DEFAULT_PARAMENTERS, ...inputParameters };

  const { mask, onKeyUp } = inputParameters;

  if (_parameters.sufix) {
    _parameters.InputProps = {
      ...{
        endAdornment: (
          <InputAdornment position="end">{_parameters.sufix}</InputAdornment>
        ),
      },
    };
  }

  if (_parameters.prefix) {
    _parameters.InputProps = {
      ...{
        startAdornment: (
          <InputAdornment position="start">{_parameters.prefix}</InputAdornment>
        ),
      },
    };
  }

  const handleKeyUp = useCallback(
    (e: any) => {
      if (mask === "cep") {
        cep(e);
      }
      if (mask === "currency") {
        currency(e);
      }
      if (mask === "cpf") {
        cpf(e);
      }

      if (mask === "cnpj") {
        cnpj(e);
      }

      if (mask === "cpf_cnpj") {
        cpfCnpj(e);
      }

      if (mask === "decimal1") {
        decimal1(e);
      }

      if (mask === "decimal2") {
        decimal2(e);
      }

      if (mask === "decimal3") {
        decimal3(e);
      }

      if (mask === "date") {
        date(e);
      }

      if (mask === "time") {
        time(e);
      }

      if (mask === "date_time") {
        dateTime(e);
      }

      if (mask === "phone") {
        phone(e)
      }

      if (mask === "credit_card_expiry") {
        creditCardExpiry(e);
      }

      if (mask === "credit_card") {
        creditCard(e);
      }

      if (mask === "credit_card_cvc") {
        creditCardCVC(e);
      }

      if (mask === "credit_card_cvc_4") {
        creditCardCVC4(e);
      }

      if (onKeyUp) {
        onKeyUp(e)
      }
    },
    [mask]
  );

  const _inputProps = _parameters?.inputProps || {}
  return <TextField
    inputRef={_parameters.ref}
    {..._parameters}
    autoFocus={inputParameters.autofocus}
    inputProps={{ ..._inputProps, maxLength: _parameters.maxLength, minLength: _parameters.minLength }}
    InputLabelProps={{
      ..._parameters.InputLabelProps,
      shrink: true
    }}
    onKeyUp={handleKeyUp}
  />;
};

export { InputText };
